import TitleArea from "../../Components/TitleArea";
import WYSIWYGContent from "../../Components/WYSIWYGContent";
import { ContentContainer } from "../../../styles";
import { PostContentWrapper  } from "./styled";
import ModuleFactory from "../../Modules/ModuleFactory";

export default function PostTemplate({ title, content, modules }) {
  const hasHero =
    modules &&
    modules.some(
      (module) =>
        module &&
        ("hero" === module.section_name || "qip_hero" === module.section_name)
    );

  return (
    <>
      <ContentContainer>
        {Boolean(title) && !hasHero && <TitleArea title={title} area="posts" />}

        {content && (
          <PostContentWrapper>
            <WYSIWYGContent content={content} />
          </PostContentWrapper>
        )}
      </ContentContainer>
      {modules &&
        modules.map((module, i) => <ModuleFactory module={module} key={i} />)}
    </>
  );
}
